import React from 'react';
import { FormattedMessage } from 'react-intl';
import Accordion from 'react-bootstrap/Accordion';
import EnrollmentsInfo from '../Enrollment/EnrollmentsInfo';

const CoverageAccordionItem = ({ applicationYear, enrollments }) => {
    return (
        <Accordion.Item eventKey={applicationYear}>
            <Accordion.Header>
                <FormattedMessage id='ga.coverage_accordion' values={{ applicationYear }}/>
            </Accordion.Header>
            <Accordion.Body>
                <EnrollmentsInfo {...{ applicationYear, enrollments }} />
            </Accordion.Body>
        </Accordion.Item>
    );
};


export default CoverageAccordionItem;